import career from "../modules/Forms/career";

career();

$(".apply-button").on('click', function() {
    let vacancy = $(this).attr('vacancy');

    $("#vaga").val(vacancy).trigger('change');
});